import RollingNumber from "./rolling_number";
import {
	removeElementById,
	templateStringToElement,
} from "shared/util/query_util";

// ========================================================================================
// GNS Count controller
// ----------------------------------------------------------------------------------------

// TODO: write RollingNumber out of this, so we can get rid of it
const Navigation = {
	counts: {},
	rawCounts: {},
	countclasstimers: {},
	started: null,

	init(params) {
		const types = Object.keys(params);

		types.forEach(function (navtype) {
			let nav = params[navtype];
			let badge = document.getElementById(`nav_${navtype}_badge`);

			if (nav.count && badge) {
				this.counts[navtype] = new RollingNumber(badge.querySelector("span.count"), nav.count);
				this.rawCounts[navtype] = nav.count;
			} else if (nav.count) {
				this.add(navtype, nav.count);
			}
		}, this);

		// the first 2.5 seconds of notifications; they could be repeats
		setTimeout(() => {
			this.started = new Date();
		}, 2500);
	},

	increment(sectionname) {
		const section = document.getElementById(`nav_${sectionname}`);
		if (!section) { return; }
		if (!this.started) { return; }

		let badge,
			animation_length = 250;

		// already has a badge
		if (this.counts[sectionname]) {
			this.counts[sectionname].increment();
			badge = document.getElementById(`nav_${sectionname}_badge`);

			// add 'incrementing' class, then remove it
			badge.classList.add("incrementing");

			// timeout must be animation time or the background transition time
			// (whichever's longer) on .badge.incrementing
			if (this.countclasstimers[sectionname]) {
				clearTimeout(this.countclasstimers[sectionname]);
			}
			this.countclasstimers[sectionname] = setTimeout(() => {
				badge.classList.remove("incrementing");
			}, animation_length);
		}

		// nary a badge to be seen
		else {
			this.add(sectionname);
		}

		// some notifs are "priority"
		// and should become pink again when a notif comes in
		if (section.classList.contains("nav-notifications--priority")) {
			section.classList.add("nav-notifications--attention");
		}
	},

	decrement(sectionname) {
		const section = document.getElementById(`nav_${sectionname}`);
		if (!section) { return; }
		if (!this.counts[sectionname]) { return; }

		this.counts[sectionname].decrement();
		this.remove(sectionname);
	},

	removeAttention(sectionname) {
		const section = document.getElementById(`nav_${sectionname}`);
		if (!section) { return; }
		section.classList.remove("nav-notifications--attention");
	},

	set(sectionname, number, params) {
		const section = document.getElementById(`nav_${sectionname}`);
		if (!section) { return; }
		if (!this.started) { return; }

		// already has a badge
		if (!this.counts[sectionname]) {
			this.add(sectionname);
		}

		if (params && params.withoutroll) {
			this.counts[sectionname].setWithoutRoll(number);
		} else {
			this.counts[sectionname].set(number);
		}
		this.remove(sectionname);
	},

	add(sectionname, count = 1) {
		const isReactNavBar = Context.has("DESKTOP_REACT_NAV_BAR");
		const reactNavbarClass = isReactNavBar ? "navbar-likes-count" : "";
		let badge,
			badgehtml = "",
			animation_length = 400;
		badgehtml += `<span class="badge entering ${reactNavbarClass}" id="nav_${sectionname}_badge">`;
		badgehtml += '	<span class="count"></span>';
		badgehtml += "</span>";

		const navbar = isReactNavBar
			? document.getElementById(`navbar-${sectionname}`)
			: document.getElementById(`nav_${sectionname}`).querySelector("a");
		navbar.append(templateStringToElement(badgehtml));

		badge = document.getElementById(`nav_${sectionname}_badge`);
		this.counts[sectionname] = new RollingNumber(badge.querySelector("span.count"), count);

		// make it slide up
		setTimeout(() => {
			badge.classList.remove("entering");
		}, animation_length);
	},

	remove(sectionname) {
		// remove IF there's no count
		const section = document.getElementById(`nav_${sectionname}`);
		if (!section) { return; }
		if (!this.counts[sectionname]) { return; }
		if (this.counts[sectionname].get()) { return; }

		this.counts[sectionname].cancel();
		this.counts[sectionname] = null;
		removeElementById(`nav_${sectionname}_badge`);
	},
};

window.Navigation = Navigation;
export default Navigation;



// WEBPACK FOOTER //
// ./src/legacy/Navigation.js